import { Grid } from '@mui/material';
import { CiCreditCard2, CiLogout } from "react-icons/ci";
import { CiLocationOn } from "react-icons/ci";
import { LuUsers2 } from "react-icons/lu";
import { MdOutlineWaterDrop } from "react-icons/md";
import { LiaCcVisa } from "react-icons/lia";
import { IoSettingsOutline } from "react-icons/io5";
import folder from '../../../assets/images/profile/bg.jpg';
import users from '../../../assets/images/profile/no_image.jpg';
import Container from '../../../constants/Container';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import ProfileInfoView from './widgets/ProfileInfoView';
import AppURL from '../../../constants/AppURL';
import AddressView from './widgets/AddressView';
import { useState } from 'react';
import ParentsView from './widgets/ParentsView';
import TapDetailsView from './widgets/TapDetailsView';
import { useNavigate } from 'react-router-dom';
import { FaFileArchive } from "react-icons/fa";
import { FaRegFilePdf } from "react-icons/fa";

const ProfileDetailsHeaderView = () => {
  const { ProfileDataDetails } = useSelector((state: RootState) => state.software);
  const [onTab, setOnTab] = useState("1");
  const navigate = useNavigate();
  return (
    <Grid container spacing={1}>
      <Grid item xl={2} md={3} xs={12} sm={12} lg={3}>
        <div className='bg-white border border-slate-200 dark:bg-sky-900 dark:border-sky-900 p-3 drop-shadow font-public-sans rounded-md'>
          <ul className='space-y-2 text-slate-700 dark:text-slate-300'>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer' onClick={() => setOnTab("1")}><CiCreditCard2 size={20} /> <span className='text-[13px] my-auto'>Profile Info</span></li>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer' onClick={() => setOnTab("2")}><CiLocationOn size={20} /> <span className='text-[13px] my-auto'>Address</span></li>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer' onClick={() => setOnTab("3")}><LuUsers2 size={20} /> <span className='text-[13px] my-auto'>Grand/Father Details</span></li>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer' onClick={() => setOnTab("4")}><MdOutlineWaterDrop size={20} /> <span className='text-[13px] my-auto'>Tap Details</span></li>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer'><LiaCcVisa size={20} /> <span className='text-[13px] my-auto'>Accounts</span></li>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer'><IoSettingsOutline size={20} /> <span className='text-[13px] my-auto'>Settings</span></li>
            <li className='flex flex-row gap-2 p-1 hover:text-sky-900 dark:hover:text-slate-50 rounded-md cursor-pointer' onClick={() => navigate('/front/office/consumer/profile/list/view')}><CiLogout size={20} /> <span className='text-[13px] my-auto'>Logout</span></li>
          </ul>
        </div>
        <div className='bg-white dark:bg-sky-900 dark:border-sky-900 mt-2 border border-slate-200 p-3 drop-shadow font-public-sans rounded-md'>
          <button className="flex items-center justify-center gap-2 ring-1 ring-slate-200 w-full rounded-sm text-center py-1.5 px-4 bg-green-600 hover:bg-green-600 text-slate-100 dark:!text-slate-100 font-medium transition-colors duration-200 ease-in-out">
            {/* <FaRegFilePdf className="my-auto" size={14} /> */}
            <span className='text-[12px]'>Download pdf</span>
          </button>
          <button className="flex items-center justify-center gap-2 ring-1 ring-slate-200 w-full rounded-sm text-center py-1.5 px-4 bg-sky-600 hover:bg-sky-900 text-slate-100 dark:!text-slate-100 font-medium transition-colors duration-200 ease-in-out">
            {/* <FaFileArchive className="my-auto" size={14} /> */}
            <span className='text-[12px]'>Download Documents</span>
          </button>
        </div>
      </Grid>
      <Grid item xl={10} md={9} xs={12} sm={12} lg={9}>
        <Container padding paddingValue='p-2'>
          <div className="bg-gradient-to-r from-green-700 via-green-700 to-green-700 drop-shadow p-1 font-public-sans rounded-md">
            <div className="border h-36 border-dashed rounded-md border-green-400 overflow-hidden">
              <img src={folder} alt="Folder" className="object-cover w-full h-full opacity-30" />
            </div>
          </div>
          <div>
            <div className="flex justify-center -mt-28 z-10 relative items-end">
              <div className={`h-36 w-36 ${ProfileDataDetails?.data?.active === 1 ? "bg-white" : "bg-red-500"} rounded-full flex items-center justify-center`}>
                <img src={ProfileDataDetails?.data?.photo ? AppURL.BaseURL + ProfileDataDetails?.data?.photo : users} alt="Folder" className="rounded-full border p-1 border-slate-200 object-cover w-full h-full" />
              </div>

            </div>
            <div className='mt-2 text-center py-1'>
              <h1 className='font-bold text-2xl mb-1 font-public-sans text-sky-700 dark:text-white'>{ProfileDataDetails?.data?.mem_name}</h1>
              <h6 className='font-normal text-[14px] font-public-sans text-slate-500 dark:text-slate-400'><span className='text-slate-600 dark:text-slate-400 font-semibold'>Marga/Tole:</span> {ProfileDataDetails?.data?.tole_name}, <span className='text-slate-600 dark:text-slate-400 font-semibold'>Phone No.:</span> +977-{ProfileDataDetails?.data?.phone_no}</h6>
            </div>
          </div>
        </Container>
        <Container padding paddingValue='p-4 mt-2'>
          {
            onTab === "1" && <ProfileInfoView ProfileDataDetails={ProfileDataDetails.data || null} />
          }
          {
            onTab === "2" && <AddressView ProfileDataDetails={ProfileDataDetails.data || null} />
          }
          {
            onTab === "3" && <ParentsView ProfileDataDetails={ProfileDataDetails.data || null} />
          }
          {
            onTab === "4" && <TapDetailsView ProfileDataDetails={ProfileDataDetails.data || null} />
          }
        </Container>
      </Grid>
    </Grid>
  )
}

export default ProfileDetailsHeaderView